import Link from "next/link";
import {FaWhatsapp, FaInstagram} from "react-icons/fa";

import Logo from "./logo";

export default function Footer() {
    return (
        <footer className='bg-white'>
            <div className='max-w-6xl mx-auto px-4 sm:px-6'>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-4 items-center pt-8 md:pt-8'>
                    {/* Logo and Company Info */}
                    <div className="flex items-center justify-center lg:justify-start space-x-3">
                        <Logo/>
                        <div>
                            <h3 className="text-sm font-semibold text-gray-800">ROTA SEVEN LTDA</h3>
                            <p className="text-xs text-gray-600">CNPJ: 58.027.562/0001-09</p>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <div className="flex justify-center">
                        <ul className='flex space-x-6 text-lg'>
                            <li>
                                <Link href='/' passHref>
                  <span
                      className='text-gray-700 hover:text-purple-600 transition duration-150 ease-in-out cursor-pointer'>
                    Home
                  </span>
                                </Link>
                            </li>
                            <li>
                                <Link href='/#about' passHref>
                  <span
                      className='text-gray-700 hover:text-purple-600 transition duration-150 ease-in-out cursor-pointer'>
                    Sobre
                  </span>
                                </Link>
                            </li>
                            <li>
                                <Link href='/#functionalities' passHref>
                  <span
                      className='text-gray-700 hover:text-purple-600 transition duration-150 ease-in-out cursor-pointer'>
                    Funcionalidades
                  </span>
                                </Link>
                            </li>
                            <li>
                                <Link href='/#plans' passHref>
                  <span
                      className='text-gray-700 hover:text-purple-600 transition duration-150 ease-in-out cursor-pointer'>
                    Planos
                  </span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Social links */}
                    <div className="flex justify-center lg:justify-end">
                        <ul className='flex space-x-2'>
                            <li>
                                <Link
                                    href='https://api.whatsapp.com/send?phone=5511940590576&text=Ol%C3%A1%20quero%20saber%20mais%20sobre%20a%20Rota%20Lounge'
                                    passHref
                                >
                                    <FaWhatsapp
                                        aria-label='WhatsApp'
                                        className='w-8 h-8 text-purple-500 hover:text-purple-400 transition duration-150 ease-in-out'
                                    />
                                </Link>
                            </li>
                            <li>
                                <Link href='https://www.instagram.com/rotalounge/' passHref>
                                    <FaInstagram
                                        aria-label='Instagram'
                                        className='w-8 h-8 text-purple-500 hover:text-purple-400 transition duration-150 ease-in-out'
                                    />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className='text-center text-base text-gray-600 my-4'>
                    © rotalounge.com.br - Todos os direitos reservados
                </div>
            </div>
        </footer>
    );
}